import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-footer-demande-devis',
  templateUrl: './footer-demande-devis.component.html',
  styleUrls: ['./footer-demande-devis.component.scss'],
  standalone: false,
})
export class FooterDemandeDevisComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  getCurrentYear(){
    return new Date().getFullYear();
  }
}
